import type { SiteContentPath } from '../types/siteContentPaths';
import { SITE_CONTENT_PATHS } from '../types/siteContentPaths';

export function isSiteContentPath(path: string): path is SiteContentPath {
    return SITE_CONTENT_PATHS.includes(path as SiteContentPath);
}
